import { Injectable } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { CognitoService, CognitoUser } from './cognito.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private readonly cognitoService: CognitoService) {}

  login(username: string, password: string): Observable<CognitoUser> {
    return this.cognitoService.login(username, password);
  }

  completeNewPassword(newPassword: string, username?: string): Observable<CognitoUser> {
    return this.cognitoService.completeNewPassword(newPassword, username);
  }

  logout(): Observable<{ message: string }> {
    return this.cognitoService.logout();
  }

  /** Vérifie si l'utilisateur est authentifié (appel réseau). */
  isAuthenticated(): Observable<boolean> {
    return this.cognitoService.me().pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }

  getCurrentUser(): CognitoUser | null {
    return this.cognitoService.getCurrentUser();
  }

  getCurrentUsername(): string | null {
    return this.cognitoService.getCurrentUsername();
  }
}

